// extracted by mini-css-extract-plugin
export default {"message":"RecoveryPasswordSendMessage_message__XJOZx","btn":"RecoveryPasswordSendMessage_btn__LInug","repeat":"RecoveryPasswordSendMessage_repeat__MzuMw"};